export default [
    {
        item: "Black Apricorn",
        tier1: "Poké Ball",
        tier2: "Great Ball",
        tier3: "Dusk Ball",
        tier4: "Luxury Ball",
        tier5: "Heavy Ball",
        tier6: "Safari Ball",
        tier7: "Sport Ball",
    },
    {
        item: "Blue Apricorn",
        tier1: "Poké Ball",
        tier2: "Great Ball",
        tier3: "Dive Ball",
        tier4: "Net Ball",
        tier5: "Lure Ball",
        tier6: "Safari Ball",
        tier7: "Sport Ball",
    },
    {
        item: "Green Apricorn",
        tier1: "Poké Ball",
        tier2: "Great Ball",
        tier3: "Ultra Ball",
        tier4: "Nest Ball",
        tier5: "Friend Ball",
        tier6: "Safari Ball",
        tier7: "Sport Ball",
    },
    {
        item: "Pink Apricorn",
        tier1: "Poké Ball",
        tier2: "Great Ball",
        tier3: "Ultra Ball",
        tier4: "Heal Ball",
        tier5: "Love Ball",
        tier6: "Safari Ball",
        tier7: "Sport Ball",
    },
    {
        item: "Red Apricorn",
        tier1: "Poké Ball",
        tier2: "Great Ball",
        tier3: "Ultra Ball",
        tier4: "Repeat Ball",
        tier5: "Level Ball",
        tier6: "Safari Ball",
        tier7: "Sport Ball",
    },
    {
        item: "White Apricorn",
        tier1: "Poké Ball",
        tier2: "Great Ball",
        tier3: "Ultra Ball",
        tier4: "Premier Ball",
        tier5: "Fast Ball",
        tier6: "Safari Ball",
        tier7: "Sport Ball",
    },
    {
        item: "Yellow Apricorn",
        tier1: "Poké Ball",
        tier2: "Great Ball",
        tier3: "Ultra Ball",
        tier4: "Quick Ball",
        tier5: "Moon Ball",
        tier6: "Safari Ball",
        tier7: "Sport Ball",
    }
]